<script>
export default {
  install(Vue) {
    var Util = function () {
      const mapArrayOfUniqueObjects = (array, fields) => {
        const result = {};
        for (let i = 0; i < array.length; i++) {
          const source = array[i];
          let target = result;
          for (let j = 0; j < fields.length; j++) {
            const field = fields[j];
            let value;
            if (Array.isArray(field)) {
              let child = source;
              for (let k = 0; k < field.length; k++) {
                if (child != undefined && child != null) {
                  child = child[field[k]];
                }
              }
              value = child;
            } else {
              value = source[field];
            }
            if (value != undefined && value != null) {
              if (!target.hasOwnProperty(value)) {
                const last = j + 1 == fields.length;
                target[value] = last ? source : {};
              }
              target = target[value];
            }
          }
        }
        return result;
      }
      return {
        mapArrayOfUniqueObjects: mapArrayOfUniqueObjects
      };
    };
    Vue.$util = new Util()
  }
}
</script>